import React, { useEffect, useState } from 'react';
import { useChatEnvironmentAtom } from '../atoms/chat/useChatEnvironmentAtom';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import useCookie from '../hooks/useCookie';
import useAuth from '../hooks/useAuth';

import '../css/pages/environment_wizard.css';
import FlagLang from '../components/shared/FlagLang';
import { optionsAtom } from '../atoms/chat/optionsAtom';
import { useEnvNameAtom } from '../atoms/chat/useEnvNameAtom';

const EnvironmentWizard = () => {

  const { userLang } = useAuth();
  const navigate = useNavigate();
  
  const [options] = useAtom(optionsAtom);
  const [, setChatEnvironmentId] = useChatEnvironmentAtom();
  const [, setEnvName] = useEnvNameAtom();
  const [envNameCookie, setEnvNameCookie] = useCookie("ENN");

  const [loading, setIsLoading] = useState(true);
  const [environmentOptions, setEnvironmentOptions] = useState([]);
  const [expandedItem, setExpandedItem] = useState(null); 

  const handleClick = async (id, name) => {
    setIsLoading(true);

    console.log(name);
    const validIds = ["30","34","32","29","26","28","33","31","27","25"];
    if (validIds.includes(id)) {
      setChatEnvironmentId(id); 

      setEnvName(name);
      setEnvNameCookie("ENN", name);

      navigate('/'); 
    } else {
      console.error('Invalid environment ID');
    }

    setIsLoading(false); 
  };

    // Update environment options based on userLang
    // const onCountryChange = (countryCode) => {
    //   if (options.hasOwnProperty(countryCode)) {
    //     setEnvironmentOptions(options[countryCode]);
    //   } else {
    //     console.error("Unsupported language");
    //   }
    // };
  
  
  useEffect(() => {
    //sk menu pre sk a cz pre cz userov
    if (userLang in options) {
      setEnvironmentOptions(options[userLang]);
    } else {
      console.error("Unsupported language");
    }
    setIsLoading(false);
  }, []);

  return (
    <div id="wizard">
        <div className='msger-logo'>
          <div className="premiumTitle-wizard">
          </div>
          <div className='country-select'>
            {/* <FlagSelect userLang={userLang}/> */}
            <FlagLang userLang={userLang}/>

          </div>
        </div>

        <div className='heading-container'>
          <span className='heading'>PREMIUM AI</span>
          {userLang === 'sk' ? (
          <>
             <span className='sub-heading'>Vitajte v PREMIUM AI pre sprostredkovateľov poistenia</span>
              <div className='heading-text'>
                <p>PREMIUM AI je tu pre Vás, aby ste rýchlo a jednoducho získali odpovede na všeobecné otázky o našich poistných produktoch. </p>
                <p>Získate tu odpovede na otázky ako dojednať poistnú zmluvu, urobiť jej zmenu, či nahlásiť poistnú udalosť.</p> 
                <p>Poradí Vám ohľadom portálu, či k postupom v našej poisťovni.</p>
                <br></br>
                <p>Najprv si prosím vyberte oblasť, ktorej sa vaša otázka týka, potom zadajte svoju otázku. </p>
                <p>V prípade, že ani v jednej oblasti nenajde odpoveď na svoju otázku, alebo Vaša otázka sa týka konkrétnej poistnej zmluvy, 
                  <br></br>neváhajte nás kontaktovať priamo. Sme tu, aby sme Vám pomohli!
                </p>
              </div>
            </>
          ) : (
            <>
            <span className='sub-heading'>Vítejte v PREMIUM AI pro zprostředkovatele pojištění</span>
              <div className='heading-text'>
                <p>PREMIUM AI je tu pro Vás, abyste rychle a jednoduše získali odpovědi na obecné otázky o našich pojistných produktech. </p>
                <p>Najdete zde odpovědi na otázky, jak sjednat pojistnou smlouvu, provést její změnu nebo nahlásit pojistnou událost.</p> 
                <p>Poradí Vám také s portálem či postupy v naší pojišťovně.</p>
                <br></br>
                <p>Nejprve si prosím vyberte oblast, které se Vaše otázka týká, a poté zadejte svůj dotaz. </p>
                <p>Pokud v žádné oblasti nenajdete odpověď na svou otázku, nebo se Váš dotaz týká konkrétní pojistné smlouvy, 
                  <br></br>neváhejte nás kontaktovat přímo. Jsme tu, abychom Vám pomohli!
                </p>
              </div>
              </>
          )}
          
         
        
        </div>


        <div className="wizWrapper">
          <div className="row">
            {environmentOptions.slice(0, 3).map((env) => (
              <div
                key={env.id}
                className={`wizItem ${env.item}`}
                onClick={() => handleClick(env.id, env.title)}
              >
                <div className={`${env.iconClass}`}></div>
                <div className="wizItemTitle">{env.title}</div>
              </div>
            ))}
          </div>
          <div className="row">
            {environmentOptions.slice(3).map((env) => (
              <div
                key={env.id}
                className={`wizItem ${env.item}`}
                onClick={() => handleClick(env.id, env.title)}
              >
                <div className={`${env.iconClass}`}></div>
                <div className="wizItemTitle">{env.title}</div>
              </div>
            ))}
          </div>
        </div>

    <div className="disclaimer">
      <span className="material-symbols-outlined">
        info
      </span>
      <div className="text-wrapper">
        {userLang === 'sk' ? (
          <>
            <p>Odpovede poskytované službou PREMIUM AI sú generované pomocou umelej inteligencie a majú informatívny charakter. Odpovede <strong>nenahrádzajú odborné poradenstvo finančného sprostredkovateľa. </strong></p><br></br>
            <p><strong>Záväzným dokumentom je vždy poistná zmluva a poistné podmienky,</strong> ktoré majú prednosť pred akoukoľvek odpoveďou generovanou službou PREMIUM AI.</p>
          </>
        ) : (
          <>
            <p>Odpovědi poskytované službou PREMIUM AI jsou generovány pomocí umělé inteligence a mají informativní charakter. Odpovědi <strong>nenahrazují odborné poradenství finančního zprostředkovatele. </strong></p><br></br>
            <p><strong>Závazným dokumentem je vždy pojistná smlouva a pojistné podmínky,</strong> které mají přednost před jakoukoli odpovědí generovanou službou PREMIUM AI.</p>
          </>
        )}
       </div>
    </div>

    </div>


  );
}

export default EnvironmentWizard;
